import { BriefcaseAccountIcon } from './BriefcaseAccountIcon';

/**
 * author: Michael Irigoyen
 * id B0F37881-7339-4CBC-9DB5-833EDCB6B049
 * name briefcase-account
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-account.svg
 * tags
 * - Account / User 
 */
export const BriefcaseUserIcon = BriefcaseAccountIcon;
export default BriefcaseUserIcon